"use client";

import React, {useEffect} from "react";
import {SDialogFC, SDialogProps} from "@/Master/SDialogFC/SDialogFC";
import {useDialogMethods} from "@/Master/SDialogFC/useDialogMethods";

export interface ErrDialogProps extends SDialogProps {
    msg: string;
}

export const ErrDialogFC: React.FC<ErrDialogProps> = (props) => {
    const {fcKey, onClose,msg,title} = props;

    const {closeDialog} = useDialogMethods(fcKey);

    useEffect(() => {
        return () => {
        };
    }, []);


    const onClickOK = () => {
        onClose?.();
        closeDialog();
    }

    return (
        <SDialogFC
            fcKey={fcKey}
            mode="Center"
            title={title}
            buttons={[
                {
                    label: "OK",
                    onClick: () => {
                        onClickOK();
                    },
                    style: "greenBtn",
                },
            ]}
        >
            <p>{msg}</p>
        </SDialogFC>
    );
};
